import { Center, Fieldset, Spinner } from '@chakra-ui/react'
import type { FC } from 'react'

import type { DashboardItem } from '@app/pages/aiDashboard/types'
import MessageContent from '@app/pages/strategies/components/aiChat/components/messageContent'
import type { DomainChat } from '@app/types'
import { ChatProcessedStateEnum } from '@graphql/types'

interface Props {
  chat?: DomainChat
  chatId?: string
  recurringReportConfiguration: DashboardItem
  showSpinner?: boolean
}

const AiDashboardPromptGeneratedReport: FC<Props> = ({
  chat,
  chatId,
  recurringReportConfiguration,
  showSpinner = false
}) => {
  let fieldsetContent = null
  const { aiPromptTestResult } = recurringReportConfiguration

  const blockMatch = (message: string) => ({
    block: null,
    priority: null,
    llmOutput: null,
    isComplete: true,
    startIndex: 0,
    endIndex: 0,
    outputRaw: null,
    visibleText: null,
    isVisible: true,
    output: message
  })

  if (showSpinner) {
    fieldsetContent = (
      <Center>
        <Spinner />
      </Center>
    )
  } else if (!chat && !chatId) {
    fieldsetContent = <MessageContent blockMatch={blockMatch('Use the "Generate" button above to test a new prompt')} />
  } else {
    switch (chat.processedState) {
      case ChatProcessedStateEnum.Idle:
        fieldsetContent = aiPromptTestResult ? (
          <MessageContent blockMatch={blockMatch(aiPromptTestResult)} />
        ) : (
          <MessageContent blockMatch={blockMatch('No report results')} />
        )
        break
      default:
        fieldsetContent = <MessageContent blockMatch={blockMatch(recurringReportConfiguration.aiPromptTestResult)} />
    }
  }

  return (
    <Fieldset.Root borderWidth={1} borderStyle="solid" borderColor="border.default" borderRadius="md" px={6} pb={6}>
      <Fieldset.Legend>Generated report</Fieldset.Legend>
      <Fieldset.Content>{fieldsetContent}</Fieldset.Content>
    </Fieldset.Root>
  )
}

export default AiDashboardPromptGeneratedReport
